import { TimePicker } from 'antd';
import {getFormatHHmiss} from 'utils/utils';
import dayjs from 'dayjs';
const format = 'HH:mm';

/**
 * @param {*}
 * @returns 시분 : HHmm
 */
export const BaseTimePicker = ({ type=undefined, value, width='6.5rem', disabled=false, onChange }) => {
  const onHandleChange = (v) => {
    if (value && onChange) {
      let obj = {};
      let key = type;
      obj[key] = dayjs(v,'HHmmss').format('HHmm')
      onChange(obj)
    };
  }

  // return <></>
  return <TimePicker 
                    defaultValue={value ? dayjs(value, 'HH:mm:ss') : dayjs(getFormatHHmiss(), 'HH:mm:ss')}
                    format={format} 
                    style={{ width: width }} 
                    disabled={disabled}
                    showNow={false} 
                    suffixIcon={''} 
                    onChange={onHandleChange}/>
};